import { T } from '@tribeplatform/react-components/i18n'

import { EmailAuth } from '../EmailAuth.js'

export function EmailAuthRouter() {
  return <EmailAuth />
}

export function EmailAuthBreadCrumb() {
  return <T id="Authentication.Email" defaultMessage="Email" />
}
